import { computed } from 'vue'
import { createQuery } from '@/queries'
import { getAvailableBrands } from '@/features/my-style/api/my-style'
import type { AvailableBrand } from '@/types/my-style'
import type { AxiosResponse } from 'axios'

type AvailableBrandsResponse = Awaited<
  ReturnType<typeof getAvailableBrands>
> extends AxiosResponse<infer T>
  ? T
  : never

export const useAvailableBrandsQuery = () => {
  return createQuery<AvailableBrandsResponse>({
    key: computed(() => ['available-brands']),
    fetcher: async () => {
      const response = await getAvailableBrands()
      return response.data
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    enabled: computed(() => true)
  })
}

